import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from './image/left.png';
import _imports_1 from '@/assets/image/mice.png';
const _hoisted_1 = {
  class: "banner"
};
const _hoisted_2 = {
  class: "left-bottom"
};
const _hoisted_3 = {
  class: "swiper-box"
};
const _hoisted_4 = ["src"];
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import { EffectFade, Autoplay } from "swiper/modules";

// import { getWmsFormData } from "@/api/wms.js";
import { webpHandle } from "@/utils/image.js";
import { onMounted } from "vue";
export default {
  __name: 'index',
  props: {
    bannerList: {
      default: () => []
    }
  },
  setup(__props) {
    const modules = [EffectFade, Autoplay];
    const props = __props;

    // getWmsFormData("wms-form-recruit-banner").then((res) => {
    //   bannerList.value = res.data;
    // });

    // const bannerList = ref([]);
    const swiperRealIndex = ref(1);
    const activeIndexChange = sw => {
      swiperRealIndex.value = sw.realIndex + 1;
    };
    onMounted(() => {
      // window.addEventListener("scroll", (e) => {
      //   console.log(1, e);
      //   console.log(2, document.documentElement.scrollTop);
      //   isTop.value = document.documentElement.scrollTop < 10;
      // });
      // document.documentElement.addEventListener("scroll", (e) => {
      //   console.log(2, e);
      // });
      // document.body.addEventListener("scroll", (e) => {
      //   console.log(e);
      // });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        srcset: ""
      }, null, -1)), _createElementVNode("span", null, _toDisplayString(_unref(swiperRealIndex)), 1)]), _createElementVNode("div", _hoisted_3, [props.bannerList.length ? (_openBlock(), _createBlock(_unref(Swiper), {
        key: 0,
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
        pagination: {
          clickable: true
        },
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        modules: modules,
        effect: 'fade',
        onSlideChangeTransitionEnd: activeIndexChange
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.bannerList, (item, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: index
          }, {
            default: _withCtx(() => [_createElementVNode("img", {
              src: _unref(webpHandle)(item.img.path),
              alt: ""
            }, null, 8, _hoisted_4)]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      })) : _createCommentVNode("", true)]), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "banner-footer"
      }, [_createTextVNode(" 下滑指示 "), _createElementVNode("img", {
        src: _imports_1,
        alt: "",
        srcset: ""
      })], -1))]);
    };
  }
};